export default __webpack_public_path__ + "static/media/juntoLogo.a2f0928e.png";